var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profiles"},_vm._l((_vm.page.profiles),function(profile){return _c('div',{key:profile._id,staticClass:"profile"},[_c('img',{attrs:{"alt":profile.name,"src":profile.image}}),_c('h3',[_vm._v(_vm._s(profile.name))]),(profile.role)?_c('p',[_vm._v(_vm._s(profile.role))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }